import { useTheme } from "@/theme/ThemeProvider";
import { AppButton } from "@/ui/components/AppButton";
import { HIT_TARGET_MIN } from "@/ui/components/listRowA11y";
import {
  FINDER_OFFLINE_DROP_BODY,
  FINDER_OFFLINE_DROP_CANCEL,
  FINDER_OFFLINE_DROP_CONFIRM,
  FINDER_OFFLINE_DROP_LABEL,
  FINDER_OFFLINE_DROP_TITLE,
  FINDER_OFFLINE_FINDER,
} from "@/ui/finder/finderMode";
import { Text, View } from "react-native";

const actionStyle = { alignSelf: "stretch" as const, minHeight: HIT_TARGET_MIN };

/**
 * Offline und Finder-Entwurf mit Inhalt: Aufnahme sperren, Verwerfen nur nach Bestätigung.
 */
export function FinderOfflineChoice({
  blocked,
  confirming,
  onRequest,
  onCancel,
  onConfirm,
}: {
  blocked: boolean;
  confirming: boolean;
  onRequest: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const { theme } = useTheme();
  if (!blocked && !confirming) return null;
  return (
    <View style={{ gap: theme.space.sm }}>
      <Text
        accessibilityRole="alert"
        style={{ color: theme.color.warningText, fontSize: theme.fontSize.body }}
      >
        {FINDER_OFFLINE_FINDER}
      </Text>
      {confirming ? (
        <View style={{ gap: theme.space.sm }}>
          <Text
            style={{
              color: theme.color.text,
              fontSize: theme.fontSize.body,
              fontWeight: "700",
            }}
          >
            {FINDER_OFFLINE_DROP_TITLE}
          </Text>
          <Text style={{ color: theme.color.text, fontSize: theme.fontSize.body }}>
            {FINDER_OFFLINE_DROP_BODY}
          </Text>
          <AppButton style={actionStyle} onPress={onCancel}>
            {FINDER_OFFLINE_DROP_CANCEL}
          </AppButton>
          <AppButton variant="outline" style={actionStyle} onPress={onConfirm}>
            {FINDER_OFFLINE_DROP_CONFIRM}
          </AppButton>
        </View>
      ) : (
        <AppButton variant="outline" style={actionStyle} onPress={onRequest}>
          {FINDER_OFFLINE_DROP_LABEL}
        </AppButton>
      )}
    </View>
  );
}
